import React, { useState } from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import logo from "../images/logo.png";
import "./NavBar.css";

const NavBar = () => {
  const [click] = useState(false);

  return (
    <Navbar
      collapseOnSelect
      className="header1"
      fixed="top"
      expand="lg"
      style={{
        backgroundColor: "white",
        position: "sticky",
        zIndex: 1,
        width: "100%",
      }}
    >
      <Container>
        <Navbar.Brand className="logos">
          <a href="/">
            <img src={logo} alt="" />
          </a>{" "}
          <i>JackThePilot</i>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav" >
          <Nav
            className={click ? "nav-menu active" : "nav-menu"}
            style={{
              marginLeft: "auto",
              marginRight: "auto",
              backgroundColor: "white",
              display: "flex",
            }}
          >

            <Nav.Link className="text-dark link" href="/flights">Flights</Nav.Link>
            <hr role="presentation" className="divider" />
            <Nav.Link className="text-dark link" href="/gift-vouchers">Gift Voucher</Nav.Link>
            <hr role="presentation" className="divider" />
            <Nav.Link className="text-dark link" href="/contact">Contact Us</Nav.Link>
            <hr role="presentation" className="divider" />
          </Nav>
        </Navbar.Collapse>

      </Container>
    </Navbar>
  );
};

export default NavBar;
